module.exports = __webpack_public_path__ + "img/mc1.0af1a760.png";